import { render, staticRenderFns } from "./FooterSalviDesktop.vue?vue&type=template&id=a3c93dd4&"
import script from "./FooterSalviDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterSalviDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports